import PointsScreen from './PointsScreen';

export default PointsScreen;